import React, { useState, useEffect } from "react";
import "./AdminPackage.css";
import { Helmet } from "react-helmet";
import "react-google-flight-datepicker/dist/main.css";
import moment from "moment";
import Slider from "react-slider-modal";
import AccomodationListingPopup from "./AccomodationListingPopup";
import ExperienceListingPopup from "./ExperienceListingPopup";
import ExperienceTransferListingPopup from "./ExperienceTransferListingPopup";
import ExperienceTransferFerryListingPopup from "./ExperienceTransferFerryListingPopup";
import VerticalTabsScrollable from "./VerticalTabsScrollable";
import {
  getAdminPackageDetails,
  getAdminPackageDetailsListing,
  SupplierUrl,
  createAdminPackages,
} from "../axios";
import Tab from "@material-ui/core/Tab";
import TabContext from "@material-ui/lab/TabContext";
import TabList from "@material-ui/lab/TabList";
import TabPanel from "@material-ui/lab/TabPanel";
import Summarydetails from "./Summarydetails";
import Policydetails from "./Policydetails";
import PackageShowcase from "./PackageShowcase";
import AccommodationOrExperienceCardView from "./PackageShowcase/AccommodationOrExperienceCardView";
import PackageRowAddComponent from "./PackageShowcase/PackageRowAddComponent";
import EmptyRowComponent from "./PackageShowcase/EmptyRowComponent";
import { useDispatch, useSelector } from "react-redux";
import { removeAdminPackageChildItem, setAdminPackageCart, setCustomerPackageDiscountPercentage } from "../../redux/actions/actions";
import CancellationForm from "./CancellationForm";
import { calculateAdminPackageBeforeDiscountAmount, calculateDiscountedAmount, countAccommodationAndExperienceByDay, countAdminPackageByItineraryType } from "./PackageShowcase/commonFunction";

function AdminPackageDetails() {
  const dispatch = useDispatch();
  const [startDate, setstartDate] = useState(null);
  const [endDate, setendDate] = useState(null);
  const [slideShow, setslideShow] = useState(false);
  const [slideExperienceShow, setslideExperienceShow] = useState(false);
  const [
    slideExperienceTransferShow,
    setslideExperienceTransferShow,
  ] = useState(false);
  const [
    slideExperienceTransferFerryShow,
    setslideExperienceTransferFerryShow,
  ] = useState(false);

  const [cats, setcats] = useState([
    { adultCounter: 1, childCounter: 0, roomCounter: 1, isExpanded: true },
  ]);
  const [addMoreLocation, setaddMoreLocation] = useState([]);
  const [selectedStartLocation, setselectedStartLocation] = useState("");
  const [selectedEndLocation, setselectedEndLocation] = useState("");
  const [totalDays, settotalDays] = useState("");
  const [itineraryDetails, setitineraryDetails] = useState([]);
  const [DatesOfDay, setDatesOfDay] = useState([]);
  const [tabData, setTabData] = useState([]);
  const [summaryTabData, setSummaryTabData] = useState([]);
  const [activityRequest, setactivityRequest] = useState({});
  const [transferRequest, settransferRequest] = useState({});
  const [transferFerryRequest, settransferFerryRequest] = useState({});
  const [accommodationRequest, setaccommodationRequest] = useState({});

  const [value, setValue] = useState("1");
  const [packageID, setPackageID] = useState();
  const [packageName, setPackageName] = useState("");
  const [packageData, setPackageData] = useState([]);
  const [previewSliderOpen, setPreviewSliderOpen] = useState(false)

  const handleChange = (_, newValue) => setValue(newValue);

  const { adminPackages, planShuffleUpdateUrl, makePackageBuildUrl } = useSelector((state) => state.adminPackageCart);

  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  const defaultZoneval = urlParams.get("moreLocation");
  const checkin = urlParams.get("checkin");
  const checkout = urlParams.get("checkout");
  const guestCombination = urlParams.get("guestCombination");
  const itineraryPlan = urlParams.get("itineraryPlan");
  const changeDate = urlParams.get("changeDate");
  const package_id = urlParams.get("package_id");

  // useEffect(() => {
  //   const handleBeforeUnload = (event) => {
  //     event.preventDefault();
  //     event.returnValue = "Are you sure you want to leave? Your changes will be lost.";
  //   };

  //   window.addEventListener("beforeunload", handleBeforeUnload);

  //   return () => {
  //     window.removeEventListener("beforeunload", handleBeforeUnload);
  //   };
  // }, []);

  useEffect(() => {
    getAdminPackageDetails(package_id).then(
      (data) => {
        setPackageName(data?.package_data?.package_name);
        settotalDays(parseInt(data?.package_data?.no_days));
      },
    );

    getAdminPackageDetailsListing(package_id).then(
      (data) => {
        if (data.itinerary_package.length) {
          let prepareData = data.itinerary_package.map((packages) => ({
            itinerary_type: parseInt(packages.sequence_data[0].itinerary_type),
            child: packages.sequence_data.map((_child) => {
              const _itinerary_type = parseInt(_child.itinerary_type);

              if (_itinerary_type !== 4) {
                return {
                  itinerary_type: _itinerary_type,
                  experience_id: _child.experience_id,
                  plan_id: _child.plan_id,
                  price: _child.price,
                  experience_date: _child.start_date,
                  experience_time: _child.experience_time,
                  packageId: _child.package_id,
                  experience_adult: _child.adult,
                  experience_child: _child.child,
                  experience_infant: _child.infant,
                  experience_youth: _child.youth,
                  experience_senior: _child.senior,
                  experience_group: _child.group,
                  price_typeid: _child.price_typeid,
                  name: _child.tour_name,
                  image: _child.gallery_image[0],
                  gallery: _child.gallery_image,
                  address: _child.tour_location,
                  start_date: _child.start_date,
                  option_name: _child.option_name,
                }
              } else {
                return {
                  itinerary_type: _itinerary_type,
                  packageId: _child.package_id,
                  property_id: _child.property_id,
                  property_room_id: _child.property_room_id,
                  rate_plan_id: _child.rate_plan_id,
                  price: _child.price,
                  start_date: _child.start_date,
                  end_date: _child.end_date,
                  adult_count: _child.room_rateplan[0].adult_count,
                  child_count: _child.room_rateplan[0].child_count,
                  room_count: _child.room_rateplan[0].room_count,
                  cart_data: _child.room_rateplan.map(cart => ({
                    adultCounter: cart.adult_count,
                    childCounter: cart.child_count,
                    roomCounter: cart.room_count,
                    id: cart.id,
                    amount: cart.price,
                    room_id: cart.property_room_id,
                    roomAvail: cart.room_available
                  })),
                  name: _child.property_name,
                  image: _child.gallery_image[0],
                  gallery: _child.gallery_image,
                  address: _child.address_line_1,
                  startDate: _child.start_date,
                  endDate: _child.end_date,
                  checkIn: _child.check_in,
                  checkOut: _child.check_out,
                  roomName: _child.room_rateplan?.map(x => x.room_name)?.join(", "),
                }
              }
            })
          }));

          dispatch(setAdminPackageCart(prepareData));
          dispatch(setCustomerPackageDiscountPercentage((parseFloat(data.discount_percentage) || 0)));
        }
        setPackageData(data);
      },
    );

    let defaultZonevalJSON = JSON.parse(defaultZoneval);

    let querySearch = JSON.parse(guestCombination);

    setaddMoreLocation(defaultZonevalJSON);
    setstartDate(checkin);
    setendDate(checkout);
    setcats(querySearch);
    setPackageID(package_id);

    JSON.parse(itineraryPlan).map((itemPlan) => setitineraryDetails(itemPlan.children));

    const startDate = new Date(checkin); // Ensure `checkin` is in ISO format or a valid Date string
    const endDate = new Date(checkout); // Ensure `checkout` is in ISO format or a valid Date string

    // Normalize the start and end dates to remove time components for time zone consistency
    const start = new Date(
      startDate.getFullYear(),
      startDate.getMonth(),
      startDate.getDate()
    );
    const end = new Date(
      endDate.getFullYear(),
      endDate.getMonth(),
      endDate.getDate()
    );

    // Initialize currentDate as a copy of the start date
    const currentDate = new Date(start);

    const datesToRender = [];

    while (currentDate <= end) {
      datesToRender.push(new Date(currentDate)); // Add a copy of the current date
      currentDate.setDate(currentDate.getDate() + 1); // Move to the next day
    }

    // Set the calculated dates
    setDatesOfDay(datesToRender);
  }, []);

  useEffect(() => {
    const savedValue = localStorage.getItem("accomodationSlide");

    if (savedValue === true) {
      setslideShow(true);
    } else {
      setslideShow(false);
    }
  }, [localStorage.getItem("accomodationSlide")]);

  useEffect(() => {
    const attractionValue = localStorage.getItem("attractionSlide");

    if (attractionValue === true) {
      setslideExperienceShow(true);
    } else {
      setslideExperienceShow(false);
    }
  }, [localStorage.getItem("attractionSlide")]);

  useEffect(() => {
    const transferFerryValue = localStorage.getItem("transferFerrySlide");
    if (transferFerryValue === true) {
      setslideExperienceTransferFerryShow(true);
    } else {
      setslideExperienceTransferFerryShow(false);
    }
  }, [localStorage.getItem("transferFerrySlide")]);

  useEffect(() => {
    const transferValue = localStorage.getItem("transferSlide");
    if (transferValue === true) {
      setslideExperienceTransferShow(true);
    } else {
      setslideExperienceTransferShow(false);
    }
  }, [localStorage.getItem("transferSlide")]);

  const PopuphandleCloseClick = () => {
    setslideShow(false);
    localStorage.setItem("accomodationSlide", false);
  };
  const PopupItineraryDetails = () => <AccomodationListingPopup
    accommodation={accommodationRequest}
    close={PopuphandleCloseClick}
  />;

  const PopuphandleAccomodationListingClick = (
    accoDetails,
    IndexNumber = null
  ) => {
    setslideShow(true);
    let JsonState = {
      defaultZoneval: accoDetails?.Location?.label,
      startDate: moment(accoDetails.range[0].startDate).format("Y-MM-DD"),
      endDate: moment(accoDetails.range[0].endDate).format("Y-MM-DD"),
      guestCombination: cats,
      accopage: 1,
      accosize: 30,
      IndexNumber: IndexNumber,
      package_id: packageID,
    };
    const hotelArr = JSON.stringify(JsonState);

    setaccommodationRequest(hotelArr);
  };

  const PopupExperiencehandleCloseClick = () => {
    setslideExperienceShow(false);
    localStorage.setItem("attractionSlide", false);
  };
  const PopupExperienceItinerary = () => <ExperienceListingPopup
    experience={activityRequest}
    close={PopupExperiencehandleCloseClick}
  />;

  const PopuphandleExperienceListingClick = (
    selectedDate,
    defaultZoneval,
    IndexNumber = null
  ) => {
    setslideExperienceShow(true);
    let JsonActivity = {
      defaultZonevalActivityVal: defaultZoneval,
      dateSelected: moment(selectedDate).format("Y-MM-DD"),
      activitypage: 1,
      activitysize: 1,
      IndexNumber: IndexNumber,
      package_id: packageID,
      guestCombination: cats,
    };

    let activityArr = JSON.stringify(JsonActivity);
    setactivityRequest(activityArr);
  };

  const PopupExperienceTransferItinerary = () => <ExperienceTransferListingPopup
    experiencetransfer={transferRequest}
    close={PopupExperienceTransferhandleCloseClick}
  />;

  const PopuphandleExperienceTransferListingClick = (
    selectedDate,
    defaultZoneval,
    otherLocation = null,
    IndexNumber = null
  ) => {
    setslideExperienceTransferShow(true);
    let locationData = "";

    if (otherLocation != null) {
      locationData = [defaultZoneval, otherLocation];
    } else {
      locationData = [defaultZoneval];
    }

    let JsonActivity = {
      defaultZonevalTransferVal: locationData,
      dateSelected: moment(selectedDate).format("Y-MM-DD"),
      activitypage: 1,
      activitysize: 1,
      IndexNumber: IndexNumber,
      package_id: packageID,
      guestCombination: cats,
    };
    let transferArr = JSON.stringify(JsonActivity);
    settransferRequest(transferArr);
  };

  const PopupExperienceTransferhandleCloseClick = () => {
    setslideExperienceTransferShow(false);
    localStorage.setItem("transferSlide", false);
  };

  //Ferry Transfer Details

  const PopupExperienceTransferFerryItinerary = () => <ExperienceTransferFerryListingPopup
    experiencetransfer={transferFerryRequest}
    close={PopupExperienceTransferFerryhandleCloseClick}
  />;

  const PopuphandleExperienceTransferFerryListingClick = (
    selectedDate,
    defaultZoneval,
    IndexNumber = null
  ) => {
    setslideExperienceTransferFerryShow(true);
    let JsonActivity = {
      defaultZonevalTransferVal: defaultZoneval,
      dateSelected: moment(selectedDate).format("Y-MM-DD"),
      activitypage: 1,
      activitysize: 1,
      IndexNumber: IndexNumber,
      package_id: packageID,
      guestCombination: cats,
    };

    let transferArr = JSON.stringify(JsonActivity);
    settransferFerryRequest(transferArr);
  };

  const PopupExperienceTransferFerryhandleCloseClick = () => {
    setslideExperienceTransferFerryShow(false);
    localStorage.setItem("transferFerrySlide", false);
  };

  useEffect(() => {
    const resultData = [];
    DatesOfDay.length > 0 &&
      DatesOfDay.map((sequenceDate, indexData) => {
        let Accomodationinput = itineraryDetails.find(
          (y) =>
            moment(y.range[0].startDate).format("Y-MM-DD") <=
            moment(sequenceDate).format("Y-MM-DD") &&
            moment(y.range[0].endDate).format("Y-MM-DD") >
            moment(sequenceDate).format("Y-MM-DD")
        );
        let itineraryinput = itineraryDetails.find(
          (y) =>
            moment(y.range[0].startDate).format("Y-MM-DD") <=
            moment(sequenceDate).format("Y-MM-DD") &&
            moment(y.range[0].endDate).format("Y-MM-DD") >=
            moment(sequenceDate).format("Y-MM-DD")
        );

        const accommodationCount = countAccommodationAndExperienceByDay(adminPackages, sequenceDate, 4);
        const landAndFerryCount = countAccommodationAndExperienceByDay(adminPackages, sequenceDate, 2);
        const activityCount = countAccommodationAndExperienceByDay(adminPackages, sequenceDate, 1);
        const ferryTransfer = countAccommodationAndExperienceByDay(adminPackages, sequenceDate, 3);

        resultData.push({
          label: moment(sequenceDate).format("DD MMM Y"),

          content: (
            <div class="dayplan-wrapper" data-testid="day-plan-wrapper">
              <div id={`dayplan${indexData}`} day={indexData}></div>
              <div class="dayplan-header" style={{ top: 190 }}>
                <p class="dayplan-title">
                  Day {indexData + 1} - {itineraryinput?.Location.label}{" "}
                  {Accomodationinput?.Location.label !=
                    itineraryinput?.Location.label && (
                      <> - {Accomodationinput?.Location.label}</>
                    )}
                </p>
                <div class="day-plan-incusions-container">
                  {[
                    {
                      color: "primary",
                      count: accommodationCount,
                      label: "Hotels",
                    },
                    {
                      color: "secondary",
                      count: landAndFerryCount,
                      label: "Transfer",
                    },
                    {
                      color: "info",
                      count: ferryTransfer,
                      label: "Ferry Transfer",
                    },
                    {
                      color: "success",
                      count: activityCount,
                      label: "Activity",
                    },
                  ].map(({ color, count, label }, i) =>
                    <span key={`count-${i}`} class={`badge bg-${color} me-2`} style={{ minWidth: "70px" }}>{`${count} ${label}`}</span>)}
                </div>
              </div>
              <div
                class="dayplan-section"
                data-testid="day-plan-section-flight"
              >
                <div>
                  <div class="flightListRow flexOne column">
                    <div class="makeFlex">
                      <ul class="flight-row firstFlightRow"></ul>
                    </div>
                  </div>
                </div>
              </div>
              <div class="dayplan-header-button bg-primary-gradient shadow-sm mb-2 rounded-0" style={{ top: 235 }}>
                <div class="container">
                  <div class="row">
                    {
                      [
                        ...(!accommodationCount && DatesOfDay.length - 1 !== indexData ? [{
                          label: "Accommodations",
                          description: "Choose your ideal accommodation for a memorable stay, sorted out by location, special offers applied instantly.",
                          icon: "plus",
                          onClick: () => PopuphandleAccomodationListingClick(Accomodationinput)
                        }] : []),
                        {
                          label: "Land Transfer",
                          description: "Craft your perfect itinerary! Connect the dots with convenient transfers.",
                          icon: "plus",
                          onClick: () => PopuphandleExperienceTransferListingClick(
                            sequenceDate,
                            itineraryinput?.Location?.label,
                            selectedStartLocation != "" && indexData == 0
                              ? selectedStartLocation
                              : selectedEndLocation != "" &&
                                DatesOfDay.length == indexData + 1
                                ? selectedEndLocation
                                : null
                          )
                        },
                        {
                          label: "Ferry",
                          description: "Visit other islands: Add ferry to your island-hopping trip.",
                          icon: "plus",
                          onClick: () => PopuphandleExperienceTransferFerryListingClick(
                            sequenceDate,
                            itineraryinput?.Location?.label
                          )
                        },
                        {
                          label: "Activity",
                          description: "Add amazing attractions and things to do to your itinerary!",
                          icon: "plus",
                          onClick: () => PopuphandleExperienceListingClick(
                            sequenceDate,
                            itineraryinput?.Location?.label
                          )
                        },
                      ].map(({ label, description, icon, onClick }, i) =>
                        <div class="col-md-3">
                          <button
                            key={`service-button-${i}`}
                            class="btn btn-light btn-sm w-100 text-nowrap"
                            type="button"
                            onClick={onClick}
                            data-bs-toggle="tooltip"
                            data-bs-placement="bottom"
                            title={description}
                          >
                            <span className="fw-bold"><i class={`fa fa-${icon}`}></i> {label}</span>
                          </button>
                        </div>
                      )}
                  </div>
                </div>
              </div>

              {
                adminPackages.length > 0 ? adminPackages.map(({ child, itinerary_type }, mainIndex) => {
                  const newChild = child.filter(({
                    start_date,
                    end_date }) => itinerary_type === 4 ?
                      (moment(start_date).format("Y-MM-DD") <=
                        moment(sequenceDate).format("Y-MM-DD")) &&
                      (moment(end_date).format("Y-MM-DD") >
                        moment(sequenceDate).format("Y-MM-DD")) :
                      moment(new Date(start_date)).format("Y-MM-DD") === moment(sequenceDate).format("Y-MM-DD"));

                  if (newChild.length === 0) return null;

                  return <div class="container my-4" key={`package-${mainIndex}`}>
                    <div className="col-md-12 p-2">
                      <div className="row row-cols-1 row-cols-md-3 g-2">
                        {newChild.map((
                          {
                            image,
                            name,
                            address,
                            start_date,
                            end_date,
                            checkIn,
                            checkOut,
                            roomName,
                            price,
                            option_name,
                            experience_time
                          }, childIndex
                        ) =>
                          <AccommodationOrExperienceCardView
                            key={`package-${mainIndex}-${childIndex}`}
                            show={itinerary_type === 4 ? (moment(start_date).format("Y-MM-DD") <=
                              moment(sequenceDate).format("Y-MM-DD")) &&
                              (moment(end_date).format("Y-MM-DD") >
                                moment(sequenceDate).format("Y-MM-DD")) : moment(new Date(start_date)).format("Y-MM-DD") === moment(sequenceDate).format("Y-MM-DD")}
                            type={itinerary_type === 4 ? "Accommodation" : itinerary_type === 2 ? "Land Transfer" : itinerary_type === 3 ? "Ferry Transfer" : itinerary_type === 1 ? "Activity" : ""}
                            priority={childIndex + 1}
                            imageSrc={image}
                            propertyName={name}
                            address={address}
                            checkIn={itinerary_type === 4 && `${moment(start_date).format("D MMM Y")}, ${checkIn}`}
                            checkOut={itinerary_type === 4 && `${moment(end_date).format("D MMM Y")}, ${checkOut}`}
                            date={itinerary_type !== 4 && `${moment(start_date).format("D MMM Y")} ${experience_time ? experience_time : "Cordinate Time"}`}
                            // roomRatePlan={itinerary_type !== 4 ? option_name : ""}
                            optionName={option_name}
                            roomName={roomName}
                            price={price}
                            onRemove={() => dispatch(removeAdminPackageChildItem(mainIndex, childIndex))}
                          />
                        )}
                        <PackageRowAddComponent
                          key={`add-row-${mainIndex}`}
                          show={newChild.length < 3}
                          priority={newChild.length + 1}
                          onAdd={() => {
                            if (itinerary_type === 4) {
                              PopuphandleAccomodationListingClick(Accomodationinput, mainIndex);
                            } else if (itinerary_type === 2) {
                              PopuphandleExperienceTransferListingClick(
                                sequenceDate,
                                itineraryinput?.Location?.label,
                                selectedStartLocation !== "" && indexData === 0
                                  ? selectedStartLocation
                                  : selectedEndLocation !== "" && DatesOfDay.length === indexData + 1
                                    ? selectedEndLocation
                                    : null,
                                mainIndex
                              );
                            } else if (itinerary_type === 3) {
                              PopuphandleExperienceTransferFerryListingClick(
                                sequenceDate,
                                itineraryinput?.Location?.label,
                                mainIndex
                              );
                            } else if (itinerary_type === 1) {
                              PopuphandleExperienceListingClick(
                                sequenceDate,
                                itineraryinput?.Location?.label,
                                mainIndex
                              );
                            }
                          }}
                        />
                      </div>
                    </div>
                  </div>
                }
                ) : <EmptyRowComponent />
              }
            </div>
          ),
        });
      });
    setTabData(resultData);
  }, [DatesOfDay, packageData, adminPackages]);

  useEffect(() => {
    const sortedData = packageData?.summary
      ?.map((item, index) => ({ index, ...item })) // Include the index for stable sorting
      ?.sort((a, b) => {
        const accodata = a.check_in
          ? moment(a.check_in, "HH:mm a").toDate()
          : null;
        const accodatb = b.check_in
          ? moment(b.check_in, "HH:mm a").toDate()
          : null;

        // Handle null values for check_in
        if (accodata === null && accodatb === null) {
          return a.index - b.index; // Keep original order if both are null
        }
        if (accodata === null) return 1; // Null values go to the end
        if (accodatb === null) return -1;

        // Compare by check_in time
        return accodata - accodatb;
      })
      ?.map(({ index, ...item }) => item); // Remove index after sorting

    const resultSummaryData = [];
    DatesOfDay.length > 0 &&
      DatesOfDay.map((sequenceDate, indexData) => {
        resultSummaryData.push({
          label: moment(sequenceDate).format("DD MMM Y"),

          content: (
            <div key={`dates-of-day-${indexData}`} class="dayplan-wrapper" data-testid="day-plan-wrapper">
              {Array.isArray(sortedData) &&
                sortedData.length > 0 &&
                sortedData.map((item, index) => {
                  const dateSelected = new Date(item.start_date);
                  let DataValue = "";

                  if (item.TYPE !== "accommodation") {
                    if (
                      moment(dateSelected).format("Y-MM-DD") ===
                      moment(sequenceDate).format("Y-MM-DD")
                    ) {
                      DataValue = (
                        <div className="dayRowContainer" key={index}>
                          <div className="summaryDetailWrapper">
                            <div className="summaryDetailContainer">
                              <span className="font12 hotel-row-text-date-summary">
                                <b>
                                  {item?.check_in
                                    ? item?.check_in
                                    : "Coordinated Timing"}
                                </b>
                              </span>
                              <span className="font12">
                                {item?.time ? (
                                  <>
                                    {item?.service_name} {item?.full_address}
                                  </>
                                ) : (
                                  <>
                                    Coordinated Timing for{" "}
                                    <b>{item?.service_name}</b>{" "}
                                    {item?.full_address}: The supplier will
                                    contact you to organize.
                                  </>
                                )}
                              </span>
                            </div>
                          </div>
                        </div>
                      );
                    }
                  } else {
                    const startDate = moment(item.start_date).format("Y-MM-DD");
                    const endDate = moment(item.end_date).format("Y-MM-DD");
                    const seqDate = moment(sequenceDate).format("Y-MM-DD");

                    if (startDate <= seqDate && endDate > seqDate) {
                      if (startDate === seqDate) {
                        DataValue = (
                          <div className="dayRowContainer" key={index}>
                            <div className="summaryDetailWrapper">
                              <div className="summaryDetailContainer">
                                <p className="font12 hotel-row-text-date-summary">
                                  <b>
                                    {moment(item.check_in, ["h:mm A"]).format(
                                      "hh A"
                                    )}
                                  </b>
                                </p>
                                <span className="font12">
                                  Check-in to <b>{item.service_name}</b>{" "}
                                  {item.full_address}
                                </span>
                              </div>
                            </div>
                          </div>
                        );
                      }
                    } else if (endDate === seqDate) {
                      DataValue = (
                        <div className="dayRowContainer" key={index}>
                          <div className="summaryDetailWrapper">
                            <div className="summaryDetailContainer">
                              <p className="font12 hotel-row-text-date-summary">
                                <b>
                                  {moment(item.check_out, ["h:mm A"]).format("hh A")}
                                </b>
                              </p>
                              <span className="font12">
                                Check-out from <b>{item.service_name}</b>{" "}
                                {item.full_address}
                              </span>
                            </div>
                          </div>
                        </div>
                      );
                    }
                  }

                  return DataValue;
                })}
            </div>
          ),
        });
      });
    setSummaryTabData(resultSummaryData);
  }, [DatesOfDay, packageData.summary]);

  const saveAction = async () => {
    try {
      const modifiedAdminPackages = adminPackages.map((packages, mainIndex) =>
      ({
        ...packages, child: packages.child.map((childData, childIndex) => {
          if (childData.itinerary_type === 4) {
            return {
              itinerary_type: childData.itinerary_type,
              property_id: childData.property_id,
              price: childData.price,
              group_sequence: mainIndex + 1,
              property_sequence: childIndex + 1,
              property_start_date: childData.start_date,
              property_end_date: childData.end_date,
              property_cart_data: childData.cart_data
            }
          } else {
            return {
              itinerary_type: childData.itinerary_type,
              experience_id: childData.experience_id,
              plan_id: childData.plan_id,
              price: childData.price,
              group_sequence: mainIndex + 1,
              experience_sequence: childIndex + 1,
              experience_date: childData.experience_date,
              experience_time: childData.experience_time,
              experience_adult: childData.experience_adult,
              experience_child: childData.experience_child,
              experience_infant: childData.experience_infant,
              experience_youth: childData.experience_youth,
              experience_senior: childData.experience_senior,
              experience_group: childData.experience_group,
              price_typeid: childData.price_typeid
            }
          }
        })
      })).flatMap(item => item.child || [])

      const finalData = {
        package_id: package_id,
        itinerary_package: modifiedAdminPackages
      }

      const response = await createAdminPackages(finalData);

      if (response) {
        alert("Package Saved Successfully");
        window.location.reload(true);
      }
    } catch (error) {
      console.error("Error updating package price:", error);
      alert("Error updating package price. Please try again.");
    }
  }

  const displayPayment = () => {
    const beforeDiscountAmount = calculateAdminPackageBeforeDiscountAmount(adminPackages);
    const afterDiscountAmount = calculateDiscountedAmount(beforeDiscountAmount, parseFloat(packageData?.discount_percentage || 0));

    return (
      <div class="p-1 pakageDtlWrapTop">
        {parseFloat(packageData?.discount_percentage) > 0 &&
          <div class="packageDtlslashedOfferPrice">
            <p class="slashedPrice fw-bold">
              €{beforeDiscountAmount}</p>
            <span class="packageOfftag">
              {packageData?.discount_percentage}% OFF
            </span>
          </div>
        }
        <p class="priceContainer">
          <span class="priceDetail">
            <span>€{afterDiscountAmount}</span>
          </span>
        </p>
        <p class="excludingText">Excluding applicable taxes</p>
      </div>
    );
  }

  const handleClear = () => window.location.replace(makePackageBuildUrl);

  const goBackPlanShuffleUpdatePage = () => window.location.replace(planShuffleUpdateUrl);

  return (
    <div className="Detail-container">
      <Helmet>
        <title>Book Best Hotels in seychelles- Holidays Seychelles</title>
        <meta
          name="description"
          content="Book best hotels in Seychelles at affordable prices."
        />
        <meta
          name="keywords"
          content="Seychelles, Seychellen, best place for honeymoon,most beautiful places in the world,best honeymoon destination in the world,honeymoon places,honeymoon destinations,beautiful places in the world"
        />
      </Helmet>
      {/* <h1 style={{ color: "#fff" }}>
        Book Best Hotels in seychelles- Holidays Seychelles
      </h1> */}
      <div className="container-fluid bg-white border-bottom">
        <div className="container">
          <div className="row">
            <span className="col-md-12 py-2 px-0">
              <img src="images/logo/seyLogo.png" alt="Holiday Seychelles" className="img-fluid" style={{ width: 100 }} />
            </span>
          </div>
        </div>
      </div>
      <TabContext value={value}>
        <div className="sticky-top bg-white newTopSection appendBottom20 shadow-sm" style={{ zIndex: 998 }}>
          <div className="pageContainer">
            <div className="pageHeading">
              <h1 className="topHeading mt-0">{packageName}</h1>
              <div className="topSubBar">
                <div className="topSubHead">
                  <div className="packageTypeTagV2">
                    <span className="font11  widthMaxContent">
                      {totalDays}N/{totalDays + 1}D
                    </span>
                  </div>
                  <p className="duration-text">
                    {itineraryDetails.length > 0 &&
                      itineraryDetails.map(({ name, Location }, index) => (
                        <React.Fragment key={index}>
                          {`${name}N ${Location?.label || ""}`}
                          {index < itineraryDetails.length - 1 && (
                            <span className="black-dot"></span>
                          )}
                        </React.Fragment>
                      ))}
                  </p>
                </div>
              </div>
            </div>
            <TabList
              onChange={handleChange}
              aria-label="lab API tabs example"
              id="tabItem"
              className="mainTab"
            >
              <Tab className="fw-bold" label="Package" value="1" />
              <Tab className="fw-bold" label="Policies" value="2" />
              <Tab className="fw-bold" label="Pricing" value="3" />
              <Tab className="fw-bold" label="Summary" value="4" />
              {/* <Tab className="fw-bold" label="Preview" value="5" /> */}
            </TabList>
          </div>
        </div>

        <div className="container-fluid">
          <div className="row">
            <div className="col-md-9">
              <div class="left-section">
                <TabPanel value="1">
                  <ul
                    class="initerary-nav"
                    style={{ top: 125 }}
                    id="initeraryNav"
                    data-testid="itinerary-nav"
                  >
                    <li class="active">
                      <b class="appendRight3">{DatesOfDay.length}</b> Day
                      Itinerary
                    </li>
                    {
                      [
                        {
                          label: "Hotels",
                          count: countAdminPackageByItineraryType(adminPackages, 4),
                        },
                        {
                          label: "Transfers",
                          count: countAdminPackageByItineraryType(adminPackages, 2),
                        },
                        {
                          label: "Ferry Transfer",
                          count: countAdminPackageByItineraryType(adminPackages, 3),
                        },
                        {
                          label: "Activities",
                          count: countAdminPackageByItineraryType(adminPackages, 1),
                        },
                      ].map(({ label, count }, i) =>
                        <li key={`overall-count-${i}`} style={{ cursor: "text" }}>
                          <span className="fw-bold">{count}</span>{"  "}{label}
                        </li>
                      )
                    }
                  </ul>
                  {tabData.length > 0 && (
                    <VerticalTabsScrollable tabs={tabData} />
                  )}
                </TabPanel>
                <TabPanel value="2">
                  <div className="summaryDetailsWrapper">
                    <div className="summaryCardWrapper">
                      <CancellationForm cancellation={packageData?.cancellation} policies={packageData?.policies} packageID={packageData?.id} />
                    </div>
                  </div>
                </TabPanel>
                <TabPanel value="3">
                  <Policydetails policyData={packageData} />
                </TabPanel>
                <TabPanel value="4">
                  {summaryTabData.length > 0 && (
                    <Summarydetails summaryTabData={summaryTabData} />
                  )}
                </TabPanel>
                {/* <TabPanel value="5">
                  <PackageShowcase />
                </TabPanel> */}
              </div>
            </div>
            <div className="col-md-3">
              <div class="pakageDtlWrap appendBottom20">
                <div class="pakageDtlWrapTop">{displayPayment()}</div>
                <div class="pakageDtlWrapBottom">
                  <div class="pakageDtlRow">
                    <div class="makeFlex appendBottom6">
                      <div class="flexOne makeFlex spaceBetween">
                        <span class="latoBlack">
                          {moment(startDate).format("DD MMM")} -{" "}
                          {moment(endDate).format("DD MMM")}{" "}
                        </span>
                        <div
                          class="latoBold pointer link link-secondary"
                          onClick={handleClear}
                        >
                          Modify
                        </div>
                      </div>
                    </div>
                    {value == 1 && <button type="button" className="btn btn-sm btn-block btn-primary mt-4 mb-3 fw-bold" onClick={saveAction}>Save</button>}
                    {adminPackages.length > 0 && <button type="button" className="btn btn-sm btn-block btn-success mt-2 mb-3 fw-bold" onClick={() => setPreviewSliderOpen(true)}>Preview</button>}
                    <button type="button" className="btn btn-sm btn-block btn-danger mt-2 mb-3 fw-bold" onClick={goBackPlanShuffleUpdatePage}>Go Back</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </TabContext>
      <Slider
        id="demoID2"
        // animation="zoom"
        speed="fast"
        // closeIcon={(e)=> {setSlideShow(e)}}
        closeIcon={PopuphandleCloseClick}
        outSideClose={PopuphandleCloseClick}
        closeModal={PopuphandleCloseClick}
        toggle={slideShow}
        sliderStyle={{
          width: "900px",
          height: "100%",
          top: "0px",
        }}
        direction="right"
        render={PopupItineraryDetails}
      />
      <Slider
        id="demoID3"
        // animation="zoom"
        speed="fast"
        // closeIcon={(e)=> {setSlideShow(e)}}
        closeIcon={PopupExperiencehandleCloseClick}
        outSideClose={PopupExperiencehandleCloseClick}
        closeModal={PopupExperiencehandleCloseClick}
        toggle={slideExperienceShow}
        sliderStyle={{
          width: "900px",
          height: "100%",
          top: "0px",
        }}
        direction="right"
        render={PopupExperienceItinerary}
      />
      <Slider
        id="demoID4"
        // animation="zoom"
        speed="fast"
        // closeIcon={(e)=> {setSlideShow(e)}}
        closeIcon={PopupExperienceTransferhandleCloseClick}
        outSideClose={PopupExperienceTransferhandleCloseClick}
        closeModal={PopupExperienceTransferhandleCloseClick}
        toggle={slideExperienceTransferShow}
        sliderStyle={{
          width: "900px",
          height: "100%",
          top: "0px",
        }}
        direction="right"
        render={PopupExperienceTransferItinerary}
      />
      <Slider
        id="demoID5"
        // animation="zoom"
        speed="fast"
        closeIcon={PopupExperienceTransferFerryhandleCloseClick}
        outSideClose={PopupExperienceTransferFerryhandleCloseClick}
        closeModal={PopupExperienceTransferFerryhandleCloseClick}
        toggle={slideExperienceTransferFerryShow}
        sliderStyle={{
          width: "900px",
          height: "100%",
          top: "0px",
        }}
        direction="right"
        render={PopupExperienceTransferFerryItinerary}
      />
      <Slider
        id="demoID6"
        // animation="zoom"
        speed="fast"
        closeIcon={() => setPreviewSliderOpen(false)}
        outSideClose={() => setPreviewSliderOpen(false)}
        closeModal={() => setPreviewSliderOpen(false)}
        toggle={previewSliderOpen}
        sliderStyle={{
          width: "95%",
          height: "100%",
          top: "0px",
          overflowY: "scroll",
          padding: 20
        }}
        direction="right"
        render={<PackageShowcase />}
      />
    </div>
  );
  // }
}

export default AdminPackageDetails;
